(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.zhTw = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    domain: '',
    menuToggle: {
      label: 'MENU'
    },
    logo: {
      href: '/'
    },
    mainBtn: [{
      text: '獲取報價',
      link: '/get-quote'
    }, {
      text: '登入',
      classes: 'btn-ghost hidden-xs concur-blue',
      link: ''
    }],
    loginLink: {
      text: 'LOGIN',
      src: ''
    },
    siteLinks: [{
      title: {
        text: '產品'
      },
      list: [{
        text: 'Concur 差旅及費用',
        src: '/travel-expense'
      }, {
        text: 'Concur費用管理',
        src: '/expense-management'
      }, {
        text: 'Concur 差旅申請',
        src: '/travel-request'
      }, {
        text: 'Concur 差旅管理',
        src: '/travel-booking'
      }, {
        text: 'Concur 廠商費用管理',
        src: '/invoice-management'
      }, {
        text: 'Concur行動應用',
        src: '/expense-mobile'
      }, {
        text: '商業智慧分析',
        src: '/business-intelligence'
      }, {
        text: '預算控管',
        src: '/budget-management'
      }, {
        text: 'Concur Locate',
        src: '/concur-locate'
      }, {
        text: '獲取報價',
        src: '/get-quote'
      }]
    }, {
      title: {
        text: '方案特色'
      },
      list: [{
        text: '與 SAP 系統整合',
        src: '/sap-integration'
      }, {
        text: '台灣大車隊e化整合',
        src: '/taiwan-taxi'
      }]
    }, {
      title: {
        text: '關於 Concur'
      },
      list: [{
        text: 'Concur 的優勢',
        src: '/why-concur'
      }, {
        text: '差旅及費用管理平台',
        src: '/concur-integrated-platform'
      }, {
        text: '辦公室地點',
        src: '/contact/offices'
      }, {
        text: '人才招募',
        src: ''
      }, {
        text: '聯絡我們',
        src: '/contact'
      }]
    }, {
      title: {
        text: '資源中心 '
      },
      list: [{
        text: '資源中心',
        src: '/resource-center'
      }, {
        text: '成功案例 ',
        src: '/casestudy'
      }, {
        text: '新聞中心',
        src: '/media-resources/press-releases'
      }, {
        text: 'Concur費用管理流程體驗',
        src: '/self-guided-demo-expense-zh-tw#/',
        classes: 'call-out'
      }]
    }],
    supportLinks: [{
      text: '聯絡我們',
      href: '/contact'
    }, {
      text: '要求報價',
      href: '/get-quote-form'
    }],
    mobileAppText: {
      text: 'GET CONCUR MOBILE APP'
    }
  };
});